import React, { FC, useState } from 'react';
import {
  LAST_NAME_TEXT_MAX_LENGTH,
  PIN_MAX_LENGTH,
  isValidPin,
  validateFields,
  isValidPinOnChange,
} from '../../util/validation';
import { LAST_NAME } from '../../util/strings';
import { useDispatch, useSelector } from 'react-redux';
import { loadOfferDetails } from '../../features/offerSearch/offerSearchSlice';
import { setPinLnDetails } from '../../features/OfferValidateContainer/PinOptFlowOfferSlice';
// import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import { logAnalyticData, offerType } from '../../analytics';
import { RootState } from '../../redux/rootReducer';
import {
  PinLblContainer,
  PinLastnameInput,
  PinRowContainer,
  PinInlineErr,
  PinErrContainer,
  LnPErrContainer,
  PinCardTitleContainer,
  PinHeadWrapper,
  PinCardDescription,
  PinSearchRowContainer,
  SearchInputGrpContainer,
  PinInputGrpContainer,
  PinSubmitBtnContainer,
} from './StyledPinSearch';
import { getSiteIdentifier } from '../../util/SiteDetails';
import './PinFlowSearchPanel.scss';

declare global {
  interface Window {
    dataLayer: any[];
    ONE: any;
    Cardinal: any;
  }
}

interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  pinId?: string;
  ln?: string;
}
const PinSearch: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { pinId, localize, ln } = props;
  const [pinValue, setPinValue] = useState(pinId || '');
  const [lastName, setLastName] = useState(ln || '');
  const [buttonStatusEnabled, setButtonStatusEnabled] = useState(false);
  const [pinHasError, setPinHasError] = useState(false);
  const [pinValidated, setPinValidated] = useState(false);
  const [lastNameHasError, setLastNameHasError] = useState(false);
  const dispatch = useDispatch();
  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const isSubmitErr = useSelector((state: RootState) => state.offerDetails.hasError);
  const submitError = useSelector((state: RootState) => (isSubmitErr ? state.offerDetails.error?.errorMessageKey : ''));
  const offer: any = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const offerCode = offer?.offerCode || 'Vacation Offer';
  const siteIdentifier = getSiteIdentifier();
  /* useEffect(() => {
    pinId && pinId.toLowerCase() !== 'error' ? setPinValue(pinId) : setPinValue('');
    pinId ? (isValidPin(pinId) ? setPinHasError(false) : setPinHasError(true)) : setPinHasError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);*/

  const handleClickSubmit = () => {
    if (!isValidPin(pinValue)) {
      setPinHasError(true);
      setButtonStatusEnabled(false);
      setPinValidated(true);
    } else {
      setPinHasError(false);
      if (pinValue?.length > 0 && lastName.length > 0) {
        window.scrollTo(0, 0);
        const pinDetailsPayload: any = { pin: pinValue.toUpperCase(), lastName: lastName };
        dispatch(setPinLnDetails(pinDetailsPayload));
        dispatch(loadOfferDetails(pinValue.toUpperCase(), lastName, 'y', true));
        window.dataLayer.push({
          event: 'enter-pin-flow',
        });
        logAnalyticData(
          {
            event: 'pbePinPageSubmit',
            siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
            pageName: 'MVC ' + siteIdentifier + 'PBE PIN Page',
            pageHierarchy: '',
            server: 'MVC',
            website: 'MVC react',
            language: 'en',
          },
          {
            errorMessage: submitError,
            offerCode: offerCode,
            offerType: offerType(offer),
            flowldentifier: 'PIN',
            bookingStepName: 'MVC ' + siteIdentifier + '| PBE PIN Page',
          },
          {
            linkName: 'PBE PIN Page Submit',
            linkClickPage: 'MVC ' + siteIdentifier + 'PBE PIN Page',
          },
        );
      }
    }
  };

  const handlePinChange = (evt: any) => {
    const pinData = evt.target.value;
    setPinValue(pinData);
    if ((!isValidPinOnChange(pinData) || (!isValidPin(pinData) && pinValidated)) && pinData) {
      setPinHasError(true);
      setButtonStatusEnabled(false);
    } else {
      setPinHasError(false);
      if (lastName && !lastNameHasError && pinData) {
        setButtonStatusEnabled(true);
      } else {
        setButtonStatusEnabled(false);
      }
    }
  };

  const handleLastNameChange = (evt: any) => {
    const lastNameVal = evt.target.value;
    setLastName(lastNameVal);
    if (pinValue && lastNameVal) {
      setButtonStatusEnabled(true);
    }

    if (validateFields(LAST_NAME, lastNameVal)) {
      if (lastNameVal) {
        setLastNameHasError(true);
      }
      setButtonStatusEnabled(false);
    } else {
      setLastNameHasError(false);
      if (pinValue && !pinHasError) {
        setButtonStatusEnabled(true);
      } else {
        setButtonStatusEnabled(false);
      }
    }
  };
  return (
    <>
      <PinCardTitleContainer>
        <PinHeadWrapper>{localize('preview-sales-engine.static-content.copy.prospects.letsfindoffer')}</PinHeadWrapper>

        <PinCardDescription>
          {localize('preview-sales-engine.static-content.copy.pbeo.find-offer-description')}
        </PinCardDescription>
      </PinCardTitleContainer>
      <PinSearchRowContainer>
        <SearchInputGrpContainer>
          <PinInputGrpContainer>
            <PinLblContainer>
              {localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-preferred-invitation-label')}
            </PinLblContainer>
            <PinLastnameInput
              type="text"
              id={'pin-optimized'}
              value={pinValue}
              onChange={handlePinChange}
              maxLength={PIN_MAX_LENGTH}
              aria-label={'opt-pin'}
              //disabled={isPinDisable}
            />
            {pinHasError && (
              <PinErrContainer>
                <PinInlineErr>
                  {localize('preview-sales-engine.static-content.copy.associate-search-page.pin-field-errors#pattern')}
                </PinInlineErr>
              </PinErrContainer>
            )}
          </PinInputGrpContainer>
        </SearchInputGrpContainer>
      </PinSearchRowContainer>
      <PinSearchRowContainer>
        <div className="ln-input-grp">
          <PinRowContainer>
            <PinLblContainer>
              {localize('preview-sales-engine.static-content.copy.pbeo.pbeo-last-name-label')}
            </PinLblContainer>
            <PinLastnameInput
              type="text"
              id={'pin-optimized-LastName'}
              value={lastName}
              onChange={handleLastNameChange}
              maxLength={LAST_NAME_TEXT_MAX_LENGTH}
              aria-label={'opt-pin'}
              autoComplete={'family-name'}
            />
            {lastNameHasError && (
              <LnPErrContainer>
                <PinInlineErr>
                  {localize('preview-sales-engine.static-content.copy.prospects.lastnamevalidation')}
                </PinInlineErr>
              </LnPErrContainer>
            )}
          </PinRowContainer>
        </div>
      </PinSearchRowContainer>
      <PinSubmitBtnContainer>
        <button
          disabled={!buttonStatusEnabled}
          onClick={handleClickSubmit}
          className={!buttonStatusEnabled ? `pinSubmitBtnDisable` : `pinSubmitBtn`}
        >
          {localize('preview-sales-engine.static-content.copy.pbeo.submit-button-label')}
        </button>
      </PinSubmitBtnContainer>
    </>
  );
};
export default withLocalization(PinSearch);
